<template>
  <el-container class="homePage">
    <!--头部-->
    <el-header>
      <right-header></right-header>
    </el-header>
    <!--    左边菜单  -->
    <el-container>
      <el-aside id="aside-style" width="15%">
        <side-menu></side-menu>
      </el-aside>

      <!--    右边内容-->
      <el-main class="main-content">
        <div class="breadcrumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item
              @click="pathfn(index)"
              v-for="(pathvalue, index) in pathlist"
              :key="index"
              :to="{ path: pathvalue.path, query: pathvalue.query }"
            >
              {{ pathvalue.name }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <template v-if="isRouterAlive">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive" />
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive" />
        </template>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import SideMenu from "./asideMenu";
import RightHeader from "./rightHeader";

export default {
  name: "Home",
  components: {
    SideMenu,
    RightHeader,
  },
  mounted() {
    console.log("-----------mounted-----------");
  },
  provide() {
    console.log("-----------provide-----------");
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      prevPaths: [],
    };
  },
  computed: {
    pathlist() {
      const arr = this.pathfn(
        this.projectConfig.LEFT_MENU,
        this.$route.path,
        []
      );
      if (arr) {
        arr.forEach((p) => {
          const q = this.prevPaths.find((v) => v.name === p.name);
          if (q) {
            p.query = { ...(q.query || {}) };
          }
        });
        this.prevPaths = arr;
      }
      return arr;
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    pathfn(pathlist, target, arr) {
      var pathflag = false;
      let idx = 0;
      if (pathlist && target && arr) {
        var flag = pathlist.some((item, index) => {
          idx = index;
          if (item) {
            pathflag = this.pathfn(item.children, target, [
              ...arr,
              {
                path: item.path,
                name: item.name,
                query: item.isquery ? this.$route.query : {},
              },
            ]);
            return item.path == target || pathflag;
          }
          return false;
        });
        if (flag || pathflag) {
          var path = pathlist[idx].path
            ? pathlist[idx].path
            : pathlist[idx].children[0].path;
          return pathflag
            ? pathflag
            : [
                ...arr,
                {
                  path,
                  name: pathlist[idx].name,
                  query: this.$route.query,
                },
              ];
        }
        return false;
      }
    },
  },
};
</script>

<style>
.homePage {
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
}
.el-aside {
  /* height: calc(100vh - 60px); */
  /* min-height: 100%; */
  /* height: 100%;
  overflow: scroll; */
  /* background-color: rgb(48, 58, 74); */
  /* overflow: hidden; */
}
thead tr .el-table__cell {
  background-color: #e3e3e3;
  color: #333;
}
.el-header {
  border-bottom: 1px solid #e5e6eb;
  /*box-sizing: border-box;*/
  background-color: white;
  line-height: 60px;
}
.el-main {
  box-sizing: border-box;
  height: calc(100vh - 60px);
  display: flex !important;
  flex-direction: column;
}
.main-content {
  padding: 16px;
  /* background-color: #f3f3f3; */
  background-color: #f7f8fa;
}

.breadcrumb {
  padding-bottom: 16px;
}
.el-menu-item-group__title {
  padding: 0 !important;
}
</style>
